import { Animated, Pressable, View } from 'react-native';
import { Icon } from '@/components/Icon';
import { Text } from '@/components/Text';
import colors from '@/config/colors';
import { styles } from './styles';
import { useRotateAnimation } from '@/hooks/useRotateAnimation';

interface ExpandableSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  content: string;
}

export const ExpandableSection: React.FC<ExpandableSectionProps> = ({
  isExpanded,
  onToggle,
  content,
}) => {
  const rotate = useRotateAnimation(isExpanded, 300);

  return (
    <View style={{ gap: 16 }}>
      <Pressable
        style={styles.expandableSectionTitle}
        onPress={() => onToggle()}
      >
        <Text style={styles.expandableSectionText}>
          {isExpanded ? 'ausblenden' : 'anzeigen'}
        </Text>
        <Animated.View style={{ transform: [{ rotate }] }}>
          <Icon
            name="chevronDown"
            size={26}
            color={colors.newUI.therapist.primaryBlue80}
          />
        </Animated.View>
      </Pressable>

      {!!isExpanded && <Text>{content}</Text>}
    </View>
  );
};
